import moment from 'moment';
import i18next from 'i18next';
import { css } from 'styled-components';
import {
  adminRoles,
  commercialRoles,
  languages,
  leadDetailFieldsReadonly,
  partnerRoles,
  technicalRoles
} from '../const';
import theme from 'ui/theme';
import flagEn from 'ui/assets/img/languages-flags/en.png';

export const getPaths = (location = window.location) => {
  const { pathname = '' } = location;
  const paths = pathname.split('/');
  const params = {};
  location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    params[key] = decodeURIComponent(decodeURIComponent(value.toString()));
  });

  return {
    pathname,
    paths,
    params
  };
};

export const preventBrowserBack = () => {
  window.history.pushState(null, null, window.location.href);
  window.onpopstate = () => {
    window.history.go(1);
  };
};

export const shadeColor = (color = '#00000', percent) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100, 10);
  G = parseInt((G * (100 + percent)) / 100, 10);
  B = parseInt((B * (100 + percent)) / 100, 10);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

export const colorOpacity = (color, opacity) => {
  if (color.includes('#')) {
    const R = parseInt(color.substring(1, 3), 16);
    const G = parseInt(color.substring(3, 5), 16);
    const B = parseInt(color.substring(5, 7), 16);

    return `rgba(${R},${G},${B},${opacity})`;
  }
  const colors = color
    .substring(color.indexOf('(') + 1, color.indexOf(')') - 1)
    .split(',');
  const R = parseInt(colors[0], 10);
  const G = parseInt(colors[1], 10);
  const B = parseInt(colors[2], 10);
  return `rgba(${R},${G},${B},${opacity})`;
};

export const statusColor = ({ status }) => {
  let style;
  switch (status) {
    case 'Available':
      style = css`
        background-color: ${props =>
          colorOpacity(props.theme.colors.semantic.tertiary, '20%')};
        color: ${props => props.theme.colors.semantic.tertiary};
      `;
      break;
    case 'Charging':
      style = css`
        background-color: ${props =>
          colorOpacity(props.theme.colors.blue.one, '20%')};
        color: ${props => props.theme.colors.blue.one};
      `;
      break;
    case 'Faulted':
      style = css`
        background-color: ${props =>
          colorOpacity(props.theme.colors.semantic.primary, '20%')};
        color: ${props => props.theme.colors.semantic.primary};
      `;
      break;
    case 'Preparing':
      style = css`
        background-color: ${props => props.theme.colors.lightViolet};
        color: ${props => props.theme.colors.violet};
      `;
      break;
    case 'Disconnected':
    case 'Waiting for approval':
    default:
      style = css`
        background-color: ${props =>
          colorOpacity(props.theme.colors.black.one, '20%')};
        color: ${props => props.theme.colors.black.three};
      `;
      break;
  }
  return style;
};

export const desaturateColor = (color = '#00000', percent) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  // let M = (R + G + B) / 3;
  const M = 200;

  R = parseInt(R - ((R - M) * percent) / 100, 10);
  G = parseInt(G - ((G - M) * percent) / 100, 10);
  B = parseInt(B - ((B - M) * percent) / 100, 10);

  const RR =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

export const measureParser = measure =>
  measure.toString().includes('px') || measure.toString().includes('%')
    ? measure
    : `${measure}px`;

export const generateGreetings = () => {
  const currentHour = moment().format('HH');

  if (currentHour >= 3 && currentHour < 13) {
    return 'Good Morning';
  }
  if (currentHour >= 13 && currentHour < 19) {
    return 'Good Afternoon';
  }
  if (currentHour >= 19 && currentHour < 20) {
    return 'Good Evening';
  }
  if (currentHour >= 20 && currentHour < 3) {
    return 'Good Night';
  }
  return 'Hello';
};

export const daysWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const hoursSlots = [
  '04-08',
  '24-04',
  '20-24',
  '16-20',
  '12-16',
  '08-12'
];
export const hoursSlotsForData = [
  '4-8',
  '24-4',
  '20-24',
  '16-20',
  '12-16',
  '8-12'
];
export const daysWeekLong = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
];

export const getColorBgBubble = value => {
  if (value > 0 && value <= 2) {
    return theme().colors.bubble.four;
  }
  if (value > 2 && value <= 4) {
    return theme().colors.bubble.three;
  }
  if (value > 4 && value <= 6) {
    return theme().colors.bubble.two;
  }
  if (value > 6) {
    return theme().colors.bubble.one;
  }
  return 'white';
};

export const splitDatasetByDate = (arr = [], days) => {
  const arrOut = [];
  const nextArr = [];

  //PREPARE
  days.forEach(() => {
    arrOut.push({});
  });

  const checkAndPush = el => {
    days.forEach((d, i) => {
      if (el.startTime?.day === d) {
        arrOut.splice(i, 1, el);
      }
    });
  };

  arr.forEach(el => {
    if (arrOut.findIndex(e => e.startTime?.day === el.startTime?.day) < 0) {
      checkAndPush(el);
    } else {
      nextArr.push(el);
    }
  });

  return nextArr.length > 0
    ? [arrOut, ...splitDatasetByDate(nextArr, days)]
    : [arrOut];
};

export const valueOrDash = (val = '') =>
  val || parseInt(val, 10) === 0 ? val : '-';

export const isInternalUser = role =>
  role === partnerRoles.ADMIN || role === partnerRoles.SYSTEM_ADMIN;

export const isCommercialRole = role => commercialRoles.includes(role);

export const isTechnicalRole = role => technicalRoles.includes(role);

export const isPartnerAdmin = role => role === partnerRoles.ADMIN;

export const isAnAdmin = role => adminRoles.includes(role);

export const createFormDataForSalesforce = (
  leadInfo,
  portalId,
  partnerId,
  oId
) => {
  const formData = new FormData();
  Object.keys(leadInfo).forEach(key => formData.append(key, leadInfo[key]));
  formData.append('submit', 'Submit+Query');
  formData.append('oid', oId);
  formData.append('retURL', '');
  formData.append(portalId, '');
  formData.append(partnerId, '');
  return formData;
};

export const getLanguageData = () => {
  const languageToReturn = languages().find(
    item => item?.code === i18next.language.split('-')[0]
  );
  if (languageToReturn && languageToReturn.flag && languageToReturn.code) {
    return {
      flag: languageToReturn?.flag,
      code: languageToReturn?.code
    };
  } else {
    return {
      flag: flagEn,
      code: 'en'
    };
  }
};

export const isLeadDetailReadOnly = type => {
  //get value of object that contains elements to be readonly, depending on which type we're sending it
  const a = leadDetailFieldsReadonly.find(item => item[type?.toLowerCase()]);
  if (a) {
    return a[Object.keys(a)[0]];
  }
};
